export const ENQUIRY_CREATE_REQUEST = 'ENQUIRY_CREATE_REQUEST';
export const ENQUIRY_CREATE_SUCCESS = 'ENQUIRY_CREATE_SUCCESS';
export const ENQUIRY_CREATE_FAIL    = 'ENQUIRY_CREATE_FAIL';

export const ENQUIRY_LIST_REQUEST   = 'ENQUIRY_LIST_REQUEST';
export const ENQUIRY_LIST_SUCCESS   = 'ENQUIRY_LIST_SUCCESS';
export const ENQUIRY_LIST_FAIL      = 'ENQUIRY_LIST_FAIL';
